import { useQuery } from '@tanstack/react-query';
import { financeApi } from '@/lib/api/finance';
import { useI18n } from '@/i18n';

const yuan = (cents: number) =>
  (cents / 100).toLocaleString('zh-CN', { style: 'currency', currency: 'CNY' });

export function ContributionsTab() {
  const { t } = useI18n();
  const { data, isLoading } = useQuery({
    queryKey: ['finance-contributions'],
    queryFn: financeApi.getContributions,
  });
  if (isLoading || !data) {
    return <div className="p-6 text-gray-500">{t('common.loading')}</div>;
  }

  return (
    <div className="bg-white rounded-lg border overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-gray-500 bg-gray-50">
            <th className="p-2">{t('financePage.date')}</th>
            <th className="p-2">{t('financePage.contributor')}</th>
            <th className="p-2 text-right">{t('financePage.amount')}</th>
            <th className="p-2">{t('financePage.round')}</th>
            <th className="p-2">{t('financePage.note')}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((c, i) => (
            <tr key={i} className="border-t">
              <td className="p-2 whitespace-nowrap">{c.date}</td>
              <td className="p-2">{c.contributor}</td>
              <td className="p-2 text-right font-medium">{yuan(c.amount_cny_cents)}</td>
              <td className="p-2">{c.round_label ?? '—'}</td>
              <td className="p-2 text-gray-500">{c.note ?? '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
